/* eslint-disable eag/match-named-export */
/* tslint:disable */
// this is an auto generated file. This will be overwritten
import * as APITypes from '../API';

type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onSendEvent = /* GraphQL */ `subscription OnSendEvent($conversationId: ID!) {
  onSendEvent(conversationId: $conversationId) {
    conversationId
    id
    tenantId
    type
    userId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnSendEventSubscriptionVariables,
  APITypes.OnSendEventSubscription
>;
